import { useEffect, useState } from "react";
import { DataTable, Page } from "@iq/models";
import ViewProjectModal from "../Components/modals/ViewProjectModal";
import { listProjects } from "../Services/pm_service";

function formatDashboardDateTime(value) {
    if (!value || value === "-" || value === "N/A") {
        return "-";
    }

    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
        return String(value);
    }

    return parsed.toLocaleString();
}

const PROJECTS_TABLE_CONFIG = {
    columns: [
        {
            key: "title",
            label: "Project",
            accessor: (row) => row?.title || row?.name || "Untitled project",
            filterable: true,
            quickValues: ["A–E", "F–J", "K–O", "P–T", "U–Z"],
            width: "1.5fr",
        },
        {
            key: "status",
            label: "Status",
            accessor: (row) => row?.status || "-",
            filterable: true,
            quickValues: ["Active", "Inactive"],
            width: "1fr",
        },
        {
            key: "owner",
            label: "Owner",
            accessor: (row) => row?.owner_name || row?.owner?.name || "-",
            filterable: false,
            width: "1fr",
        },
        {
            key: "priority",
            label: "Priority",
            accessor: (row) => row?.priority || "-",
            filterable: false,
            width: ".75fr",
        },
        {
            key: "updatedAt",
            label: "Updated",
            accessor: (row) => formatDashboardDateTime(row?.updated_at || row?.updatedAt),
            filterable: true,
            quickValues: ["Most Recent", "Oldest"],
        },
    ],
};

function ProjectsPage() {
    const [projects, setProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);
    const [loadingProjects, setLoadingProjects] = useState(false);

    useEffect(() => {
        async function loadProjects() {
            setLoadingProjects(true);
            try {
                const data = await listProjects();
                console.log(data);
                setProjects(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error("Failed to load projects: ", err);
                setProjects([]);
            } finally {
                setLoadingProjects(false);
            }
        }
        loadProjects();
    }, []);

    return (
        <Page>
            <div className="pm-project-list" style={{ alignContent: "center" }}>
                <DataTable
                    rowData={projects}
                    loading={loadingProjects}
                    tableConfig={PROJECTS_TABLE_CONFIG}
                    onRowClick={(project) => setSelectedProject?.(project)}
                />
            </div>
            {selectedProject && (
                <ViewProjectModal
                    isOpen={Boolean(selectedProject)}
                    project={selectedProject}
                    tasks={[]}
                    onClose={() => setSelectedProject(null)}
                />
            )}
        </Page>
    );
}

export default ProjectsPage;